import { Link } from 'react-router-dom';
import { principles, site, testimonials } from '@/mocks/guagua';
import SectionHeading from '@/components/base/SectionHeading';

export default function BrandSection() {
  return (
    <section className="px-4 md:px-6 py-12 md:py-16" aria-labelledby="home-brand">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          eyebrow="About Gua Ge"
          title="热闹是别人的，分寸是自己的"
          desc="瓜哥吃瓜不追求最快，只想在“快”和“准”之间找个平衡点。下面这些，是我们一直在坚持的事。"
          href="/about"
          hrefLabel="了解瓜哥"
        />
        <h2 id="home-brand" className="sr-only">
          关于瓜哥吃瓜
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {principles.map((item) => (
            <div
              key={item.title}
              className="p-5 rounded-lg bg-background-100 border border-background-200"
            >
              <span className="flex items-center justify-center w-11 h-11 rounded-md bg-primary-500 text-background-50 text-xl">
                <i className={item.icon} aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 md:mt-14 grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-5">
          {testimonials.map((item) => (
            <blockquote
              key={item.name}
              className="flex flex-col p-6 rounded-lg bg-secondary-50 border border-secondary-200"
            >
              <i className="ri-double-quotes-l text-2xl text-secondary-400" aria-hidden="true"></i>
              <p className="mt-3 text-sm md:text-base text-foreground-700 leading-relaxed flex-1">
                {item.text}
              </p>
              <footer className="mt-4 pt-4 border-t border-secondary-200 flex items-center gap-3">
                <span className="flex items-center justify-center w-9 h-9 rounded-full bg-secondary-500 text-background-50 font-medium">
                  {item.name.slice(0, 1)}
                </span>
                <span>
                  <span className="block text-sm font-medium text-foreground-900">{item.name}</span>
                  <span className="block text-xs text-foreground-500">{item.tag}</span>
                </span>
              </footer>
            </blockquote>
          ))}
        </div>

        <div className="mt-10 md:mt-14 flex flex-col md:flex-row items-start md:items-center justify-between gap-5 p-6 md:p-8 rounded-lg bg-foreground-950">
          <div>
            <h3 className="font-heading text-xl md:text-2xl font-bold text-background-50">
              有线索？想推荐话题？
            </h3>
            <p className="mt-2 text-sm text-background-300 max-w-lg">
              把可核实的公开来源发给我们，核实通过后会在栏目里注明线索来源。{site.tagline}
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href={`mailto:${site.email}`}
              rel="nofollow"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-mail-send-line" aria-hidden="true"></i>
              联系瓜哥
            </a>
            <Link
              to="/news"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-50/40 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-background-50/10 transition-colors cursor-pointer"
            >
              去逛新瓜速递
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}